import { SET_LANG } from "./action.type";

export const setLang = (data, country) => dispatch => {
    localStorage.setItem('lang', data);
    localStorage.setItem('country', country)
    dispatch({ type: SET_LANG, payload: JSON.parse(data), country: country })
}

